// src/pages/home/Home.jsx
// PURPOSE:
// - Mobile View NUR auf echten Mobile-Geräten
// - Desktop bleibt Desktop, auch bei schmalem Fenster

import React from "react";
import HomeDesktop from "./HomeDesktop";
import HomeMobile from "./HomeMobile";

// 🔑 Echte Device-Erkennung (kein Resize!)
const isMobileDevice = () => {
    return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
};

const Home = () => {
    return isMobileDevice() ? <HomeMobile /> : <HomeDesktop />;
};

export default Home;
